"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  s1: '4px',
  s2: '8px',
  s3: '12px',
  s4: '16px',
  m1: '24px',
  m2: '32px',
  m3: '40px',
  m4: '48px',
  l1: '64px',
  l2: '80px',
  l3: '96px',
  xl: '128px'
};